module.exports = __webpack_public_path__ + "static/media/tmdbLogo.08392f18.svg";